exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#doc-manager #details .save-btn{margin-left:8px}#doc-manager #details .details-container{padding:20px 0;min-width:500px}#doc-manager #details .details-container form{max-width:50%}#doc-manager #details .details-container span{font-size:14px!important;color:#5b6981}", ""]);

// exports
